import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    dialogCloseLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for close dialog button */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useManageGenerateTranscriptionDialog.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
